export function generateInviteToken(seed: string = crypto.randomUUID()): string {
  const normalizedSeed = seed.replace(/[^a-zA-Z0-9]/g, "").slice(0, 18);
  const randomPart =
    typeof crypto.getRandomValues === "function"
      ? Array.from(crypto.getRandomValues(new Uint8Array(8)))
          .map((value) => value.toString(16).padStart(2, "0"))
          .join("")
      : Math.random().toString(36).slice(2, 14);

  return `invite_${normalizedSeed}_${randomPart}`.toLowerCase();
}

export function buildInviteLink(baseUrl: string, inviteToken: string): string {
  return `${baseUrl.replace(/\/$/, "")}/invite/${encodeURIComponent(inviteToken)}`;
}
